// extracted by mini-css-extract-plugin
export default {"container":"CX-z","title":"DX-z","link":"EX-z"};